import React from 'react';
const VisaCard = ({ ...r }) => {
	return (
		<svg
			width="50"
			height="32"
			viewBox="0 0 50 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...r}
		>
			<rect
				x="0.525391"
				width="48.8421"
				height="32"
				rx="4"
				fill="url(#paint0_linear_716_36747)"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M31.8493 17.6517C31.8556 16.0644 30.5465 15.3788 29.5305 14.8467C28.8874 14.5099 28.3617 14.2346 28.3617 13.831C28.3617 13.4875 28.6948 13.1231 29.4028 13.0294C30.2453 12.946 31.0946 13.0936 31.8597 13.4562L32.2969 11.3741C31.5511 11.0944 30.7615 10.9499 29.9649 10.9473C27.508 10.9473 25.8007 12.259 25.8007 14.1329C25.8007 15.5175 27.0395 16.2879 27.9765 16.746C28.9135 17.2041 29.2778 17.5268 29.2674 17.9432C29.2674 18.5887 28.497 18.8802 27.7787 18.8906C26.8926 18.902 26.0183 18.687 25.2385 18.266L24.7908 20.3481C25.6731 20.6925 26.613 20.8657 27.5601 20.8582C30.1732 20.8582 31.8909 19.5673 31.9013 17.5684L31.8493 17.6517ZM25.0927 11.114L23.0106 20.7439H20.512L22.5942 11.114H25.0927ZM35.5659 17.3607L36.8776 13.7482L37.6376 17.3607H35.5659ZM40.6567 20.7754H38.3455L38.0436 19.3387H34.91L34.3999 20.7754H31.7764L35.5138 11.8534C35.6861 11.429 36.0968 11.1497 36.5549 11.1455H38.637L40.6567 20.7754ZM17.545 20.7124L21.5843 11.0825H18.8776L16.2853 17.6308L15.2443 12.0611C15.1521 11.4951 14.6621 11.0802 14.0887 11.0825H9.85153L9.78906 11.3636C10.6389 11.5299 11.4644 11.8027 12.246 12.1756C12.5789 12.3321 12.8045 12.6527 12.8394 13.0189L14.8278 20.7124H17.545Z"
				fill="white"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_716_36747"
					x1="0.525391"
					y1="32"
					x2="49.3675"
					y2="-2.45428e-06"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#2A2A6C" />
					<stop offset="1" stop-color="#26449A" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default VisaCard;
